export const name = 'download';

export const Download = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      color="#161619"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2L12 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 11.5L12 16L7.5 11.5L8.5 10.5L12 14L15.5 10.5L16.5 11.5Z"
        fill="currentColor"
      />
      <path
        d="M4 20H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
